module.exports = __webpack_public_path__ + "img/Lesotho.3e75b091.png";